import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../../../models/hooks';
import { useExitPrompt } from '../companyManagement/useExitPrompt';

export function useWatchFormDataChange(): void {
  const [, setShowExitPrompt] = useExitPrompt(false);
  const {
    initialFormSchema,
    formSchema,
    defaultLanguage,
    currentLanguage,
    availableLanguages,
    templateName,
    needFinalSignature,
    disclaimerText,
    showExitPrompt,
  } = useStoreState((state) => state.formBuilder);
  const setShowExit = useStoreActions((actions) => actions.formBuilder.setShowExitPrompt);

  useEffect(() => {
    setShowExitPrompt(showExitPrompt);
  }, [showExitPrompt, setShowExitPrompt]);

  useEffect(() => {
    setShowExit(
      JSON.stringify(initialFormSchema) !==
        JSON.stringify({
          formSchema,
          defaultLanguage,
          currentLanguage,
          availableLanguages,
          templateName,
          needFinalSignature,
          disclaimerText,
        }),
    );
  }, [
    initialFormSchema,
    formSchema,
    defaultLanguage,
    currentLanguage,
    availableLanguages,
    templateName,
    needFinalSignature,
    disclaimerText,
    setShowExit,
  ]);
}
